import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IGroupSetGroupInfo } from '../../models/IGroupSetInfo';
import { createBaseRestConfig } from '../GroupSetsServerApiHelper';

export interface IDeleteGroupSetRequestBody {
}

export interface IRemoveGroupFromGroupSetResult extends IResult {
}

export async function removeGroupFromGroupSet(group: IGroupSetGroupInfo): Promise<IRemoveGroupFromGroupSetResult> {
    const config: RestApiRequestConfig<{}, {}> = {
        ...createBaseRestConfig(),
        httpMethod: 'DELETE',
        endpoint: `groupsets/` + group.groupSetId + '/groups/' + group.groupLuid,
    };

    let response = makeRestApiRequest<{}, any, {}>(config);
    return response.then((result: any) => {
        return result;
    }, (error) => Promise.reject(error));
}